import Request from './request'
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'


async function fetch(data) {
    return Request('get', "api/stock-out-orders", data);
}

async function fetchOne(id, data) {
  return Request('get', "api/stock-out-orders/view/" + id, data);
}

async function out(data) {//出库
  return Request('post', "api/stock-out-orders/out", data)
}

async function edit(data) {//编辑
  return Request('post', "api/stock-out-orders/edit", data)
}

async function add(data) {// 编辑出库单
  //data = delSomeFields(data);// 去除过多杂项
  return Request('post', "api/stock-out-orders/add", data);
}

async function cancel(id) {// 作废出库单
  return Request('post', "api/stock-out-orders/cancel/" + id);
}

async function exports(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-out-orders/export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function shopOffReturnOrder() {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-out-orders/shop-off-return-order-save')
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('stockOutOrders.shop_off_return_order_msg'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function detailExport(id) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-out-orders/detail-export/'+id)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function addReturnView(data) {
  return Request('post', "api/stock-out-orders/add-return-view/", data);
}

async function addReturn(data) {
  return Request('post', "api/stock-out-orders/add-return/", data);
}

async function returnOrderView(id, data) {
  return Request('get', "api/stock-out-orders/return-order-view/" + id, data);
}

async function rePushReturnOrder(id, data) {
  return Request('get', "api/stock-out-orders/re-push-return-order/" + id, data);
}

async function orderOutPrint(id) {
  return Request('get', 'api/stock-out-orders/stock-order-print/' + id)
}

// 导出商品模板
async function commonTemplateExport(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-out-orders/common-template-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function importMaterials(file) {      //普通模板导入
  var data = new FormData()
  data.append('excel', file)
  return Request('post', "api/stock-out-orders/import-materials", data)
}


async function update(data) {
  return Request('post', 'api/stock-out-orders/update', data)
}

export default {
  fetch,
  out,
  edit,
  cancel,
  fetchOne,
  add,
  exports,
  detailExport,
  addReturnView,
  addReturn,
  returnOrderView,
  rePushReturnOrder,
  orderOutPrint,
  commonTemplateExport,
  importMaterials,
  update,
  shopOffReturnOrder,
}